import styled from 'styled-components'
import Text from '~/components/Text'
import breakpoints from '~/components/UI/breakpoints'

const SharedTitle = styled(Text)`
  font-size: 36px;
  font-weight: bold;
  line-height: 1.4;
  ${breakpoints.lg} {
    font-size: 48px;
  }
`
export default SharedTitle
